$(document).on('ready', function () {

    let elem = document.getElementById('sciencetab-carousel');
    let width = $(window).width();
    let align = 'center';
    if (width > 992) {
        align = 'left';
    }
    var flkty = new Flickity(elem, {
        // options
        cellAlign: align,
        contains: false,
        freeScroll: false,
        prevNextButtons: false,
        pageDots: true,
        percentPosition: true
    });

    // Call this when carousel is initialized and/or after its contents change
    function setUniformCardHeight() {
        const cells = document.querySelectorAll('.product-content');
        let maxHeight = 0;
        cells.forEach(cell => {
            cell.style.height = 'auto'; // reset height
            maxHeight = Math.max(maxHeight, cell.offsetHeight);
        });
        cells.forEach(cell => {
            cell.style.height = maxHeight + 'px';
        });
    }

    window.addEventListener('load', setUniformCardHeight);
    window.addEventListener('resize', setUniformCardHeight);

    // products adding
    // $(document).on('click', '.toggle-icon', function () {
    //     $(this).toggleClass('item-added');
    // });
});


// Step By Step

$(document).on('ready', function () {

    let elem = document.getElementById('step-carousel');
    let width = $(window).width();
    let align = 'center';
    if (width > 992) {
        align = 'left';
    }
    var flkty = new Flickity(elem, {
        // options
        cellAlign: align,
        contains: false,
        freeScroll: false,
        prevNextButtons: false,
        pageDots: true,
        percentPosition: true
    });




    var maxHeight = 0;

    // Loop through all elements with class "numbers"
    $(document).find('.numbers').each(function () {
        var thisHeight = $(this).height();
        if (thisHeight > maxHeight) {
            maxHeight = thisHeight; // update maxHeight if this element is taller
        }
    });

    // Set all elements with class "numbers" to the tallest height
    $(document).find('.numbers').height(maxHeight);
    setTimeout(function () {
        $(document).find('.numbers').height(maxHeight);
    }, 200);

});